var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#36A1C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 20C26 20.1326 25.9473 20.2598 25.8536 20.3536C25.7598 20.4473 25.6326 20.5 25.5 20.5H20.5V25.5C20.5 25.6326 20.4473 25.7598 20.3536 25.8536C20.2598 25.9473 20.1326 26 20 26C19.8674 26 19.7402 25.9473 19.6464 25.8536C19.5527 25.7598 19.5 25.6326 19.5 25.5V20.5H14.5C14.3674 20.5 14.2402 20.4473 14.1464 20.3536C14.0527 20.2598 14 20.1326 14 20C14 19.8674 14.0527 19.7402 14.1464 19.6464C14.2402 19.5527 14.3674 19.5 14.5 19.5H19.5V14.5C19.5 14.3674 19.5527 14.2402 19.6464 14.1464C19.7402 14.0527 19.8674 14 20 14C20.1326 14 20.2598 14.0527 20.3536 14.1464C20.4473 14.2402 20.5 14.3674 20.5 14.5V19.5H25.5C25.6326 19.5 25.7598 19.5527 25.8536 19.6464C25.9473 19.7402 26 19.8674 26 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add-button.9dca8b8fad30137575007bf41e3848b9.svg";
export { ForwardRef as ReactComponent };